import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/myitemcard.module.scss'

import { getImageUrl } from '../util/images'
import FavoriteItem from '../items/FavoriteItem'
import { getItemUserStatus } from '../components/utils'
import { formatMoney } from 'services/util'

export default function MyFixedItemCard({item, auction, currentUserId, currentFavItems}) {

  const [imageUrl, setImageUrl] = useState()

  const itemUserStatus = getItemUserStatus(auction, item, currentUserId)
  const outlineClass = itemUserStatus ? themeCss[`outline-${itemUserStatus}`] : ''

  const quantityPurchased = item?.MyAmountPurchased
  
  let auctionState = ''
  const now = new Date()
  const startDate = new Date(auction.StartTime)
  startDate < now ? auctionState = 'started' : auctionState = 'before'


  // use effect for auction banner image
  useEffect(() => {
    const url = getImageUrl(auction?.AuctionCode, item?.ItemCode, item?.ImageFilename)
    setImageUrl(url)
  }, [auction, item])

  //if the user has not bought anything AND it is not in the favorites, we don't want to show it here
  if ((quantityPurchased === 0 || quantityPurchased === undefined || quantityPurchased === null)
    && !currentFavItems.includes(item.FixedItemId) ) return <></>

  return (
    <div className={`${css['myitem-container']} ${themeCss['shadowed']} ${outlineClass}`}>
      <Link className={css['myitem-image']} to={{ pathname: '/auction/fixeditem', search: `?auctionId=${auction.AuctionCode}&fixedItemId=${item.ItemCode}`}}>
        <img src={imageUrl} alt={`${item.Title}`} />
        <p className={`${css['myitem-title']} ${themeCss['truncate-twoline']}`}>
          {item.Title}
        </p>
      </Link>

      <div className={css['myitem-notification-row']}>
        <p className={quantityPurchased > 0 ? themeCss['purchase-notification'] : themeCss['hidden']}>
          Quantity purchased: {quantityPurchased}
        </p>
      </div>

      {auctionState !== 'before' && 
      <div className={css['myitem-bidinfo']}>
        <p>
          Total Price: <span>${formatMoney(item.PurchasePrice * quantityPurchased)}</span>
        </p>
        <p className={css['myitem-bidcount']}>{item.MyAmountPurchased} {item.MyAmountPurchased === 1 ? 'item' : 'items'}</p>
      </div>}

      <div className={css['myitem-footer']}>
        <FavoriteItem auctionId={auction.AuctionId} itemId={item.FixedItemId}/>
        <Link to={{ pathname: '/auction/fixeditem', search: `?auctionId=${auction.AuctionCode}&fixedItemId=${item.ItemCode}`}}
            className={`${css['myitem-view-link']}`}>
          View Item Details
        </Link>
      </div>

    </div>
  )
}